import React from 'react';
import { motion } from 'framer-motion';
import { BarChart2 } from 'lucide-react';
import { Product } from '../../../types/Product';
import { PriceDistributionChart } from './PriceDistributionChart';
import { CategoryDistributionChart } from './CategoryDistributionChart';

interface StatisticsChartsProps {
  products: Product[];
}

export const StatisticsCharts: React.FC<StatisticsChartsProps> = ({ products }) => {
  return (
    <div className="space-y-6">
      <div className="flex items-center gap-2 mb-4">
        <BarChart2 className="text-orange-500" size={20} />
        <h3 className="text-lg font-semibold">Análisis Detallado</h3>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <motion.div
          whileHover={{ scale: 1.01 }}
          className="bg-white rounded-lg shadow-sm p-6"
        >
          <PriceDistributionChart products={products} />
        </motion.div>

        <motion.div
          whileHover={{ scale: 1.01 }}
          className="bg-white rounded-lg shadow-sm p-6"
        >
          <CategoryDistributionChart products={products} />
        </motion.div>
      </div>
    </div>
  );
};